export interface WizardMobileOptionsSheetProps {
  onSaveAsDraft: VoidFunction;
  onSchedule: VoidFunction;
}

export const WIZARD_MOBILE_OPTIONS_SHEET_PANEL_ID = 'wizard-mobile-options-sheet-panel';

export enum WizardMobileOptionsSheetItemId {
  SAVE_DRAFT = 'wizard-mobile-options-save-draft',
  SCHEDULE = 'wizard-mobile-options-schedule',
}

export const SAVE_DRAFT_ICON_CLASSES = 'icon icon-save';
export const SCHEDULE_ICON_CLASSES = 'icon icon-calendar';
